import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=13ddb5d0&"
import script from "./lists.vue?vue&type=script&lang=ts&"
export * from "./lists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports